import React from 'react';

const EnergyAudit = ({ userName, createdAt }) => {
  const scaleItems = [
    { score: '1', meaning: 'Never' },
    { score: '2', meaning: 'Rarely' },
    { score: '3', meaning: 'Sometimes' },
    { score: '4', meaning: 'Often' },
    { score: '5', meaning: 'Always' },
  ];

  return (
    <>

      <main className="py-10 space-y-10 bg-white">
        <section className="flex flex-col space-y-10 ">
          <div className="flex flex-col space-y-8 text-left">
            <div className="flex justify-start items-start pt-2 pl-28">
              <img src="/img/logo/mile_logo.png" alt="Logo" className="w-56" />
            </div>
            <div className="py-2 space-y-4 text-left pl-28">
              <h1 className="text-6xl text-gray-900 font-bold text-left items-center justify-center">ENERGY PROFILE <br /><span className="text-gray-900 font-medium">REPORT</span></h1>
              <h1 className="text-lg font-semibold text-[#009688]">Understanding Your Energy Capacity</h1>
            </div>
            <div className="flex justify-center pt-6">
              <img src="/userdashboard/energy-profile-report.png" alt="TalentPlusStrengths Assessment Report" className="w-full h-full mx-auto" />
            </div>

            <div className="text-left pl-32 pt-12">
              <h2 className="flex items-center space-x-4 text-lg text-gray-900">
                <span className='w-12 font-bold'>Name:</span>
                <span className='font-medium'>{userName}</span>
              </h2>
              <h2 className="flex items-center space-x-4 text-lg text-gray-900">
                <span className='w-12 font-bold'>Date:</span>
                <span className='font-medium'>{createdAt}</span>
              </h2>
            </div>
            <div className="text-left pl-32 pt-12">
              <p className="text-lg text-[#212121] font-medium">Pitstop Consultancy Pvt. Lts. Online Assessments Copyright 2026</p>
              <p className="text-base font-medium text-[#212121]/70 italic">This report is confidential and should not be distributed without permission</p>
            </div>
          </div>
        </section>
      </main>

      <div className="p-10 px-6 space-y-6 bg-white">
        <div className="px-12 space-y-6 page-break">
          <div className="flex items-center justify-between w-full pt-4 pb-2 border-b text-[#212121]/85 italic">
            <h1 className="text-lg font-semibold">Energy Profile Report</h1>
            <p className="text-lg font-semibold">{userName} | {createdAt}</p>
          </div>

          {/* Title Section */}
          <div className="mt-6 mb-6">
            <h1 className="text-3xl font-bold text-gray-900 tracking-tight">
              The Full Engagement Energy Audit
            </h1>
            <p className="text-sm font-medium text-gray-600 mt-1">
              Managing energy, not time - the science of sustained high performance.
            </p>
          </div>

          {/* Core Narrative Content */}
          <div className="space-y-4 text-base text-gray-700 leading-relaxed">
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Why energy, not time?
              </h3>
              <p className='text-base text-gray-900'>
                Most high performers manage their calendars meticulously yet still end the week depleted. The reason is
                simple: time is finite and fixed, but energy is renewable and expandable. Performance is ultimately a function
                of the energy you bring to each moment, not the hours you log. This audit reframes the unit of high
                performance from time to energy across four interdependent dimensions - Physical (the quantity of energy),
                Emotional (its quality), Mental (its focus), and Spiritual (its force and purpose).
              </p>
            </div>

            <p className='text-base text-gray-900'>
              The central mechanism is oscillation: the rhythmic movement between energy expenditure (stress) and
              energy renewal (recovery). Just as a muscle grows only when stress is followed by rest, capacity in every
              dimension expands when intense engagement is deliberately paired with intentional recovery. Chronic
              linearity - pushing without pausing - erodes capacity and drives burnout; chronic underuse atrophies it.
            </p>

            <p className='text-base text-gray-900'>
              Sustained high performance therefore depends on building energy capacity through rituals and managing
              oscillation on purpose. This instrument measures how much energy you have, how well you spend it, and how
              reliably you renew it - then trangrays that into an actionable development plan.
            </p>
          </div>

          {/* <div className="mt-6 mb-6">
            <h3 className="text-xl font-bold text-gray-900 mb-3">
              How to use this audit
            </h3>
            <ol className="list-decimal pl-4 space-y-2 text-base text-gray-900">
              <li>Go to the Assessment tab and answer all 40 statements honestly, using The 1-5 Scale below.</li>
              <li>Rate based on observable behaviour over the last 30 days - how you actually act, not how you aspire to.</li>
              <li>Your scores, profile, and bands calculate automatically on the YOUR ENERGY PROFILE tab.</li>
              <li>Review BURNOUT RED FLAGS for your low-scoring dimensions, then build your plan in ACTION FRAMEWORK.</li>
            </ol>
          </div>
          <div className="mb-6">
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              The 1-5 Scale
            </h3>
            <div className="w-full border-2 border-white rounded-sm overflow-hidden">
              <table className="w-full text-center text-base border-collapse">
                <thead>
                  <tr className="bg-sky-800 text-white font-semisemibold">
                    <th className="p-2 border-r-2 border-white w-1/3">Score</th>
                    <th className="p-2">Meaning</th>
                  </tr>
                </thead>
                <tbody className="divide-y-2 divide-white">
                  {scaleItems.map((item, idx) => (
                    <tr key={idx} className={idx % 2 === 1 ? 'bg-gray-100' : 'bg-gray-100'}>
                      <td className="p-2 font-bold text-gray-900 border-r-2 border-white">{item.score}</td>
                      <td className="p-2 text-gray-900 font-medium">{item.meaning}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <p className="text-sm text-gray-900 leading-normal">
            Based on the Energy Management framework of The Power of Full Engagement (Loehr & Schwartz, Human Performance Institute).
          </p> */}
        </div>
      </div>

    </>
  );
};

export default EnergyAudit;